import { Box, Typography, Switch } from "@mui/material";
import { Layer } from "../../types/layer";
import LayerControlItem from "./LayerControlItem";
import ThreeDShapesIcon from "../icons/ThreeDShapesIcon";
import {
  useFuel3DOptions,
  setFuel3DOption,
  Fuel3DOptionKey,
} from "../../hooks/use3DFuelOptions";

interface FuelLoad3DControlProps {
  layer: Layer | null;
  expanded?: boolean;
  onExpandedChange?: (expanded: boolean) => void;
  onPanelOpenChange?: (open: boolean) => void;
}

const ROWS: { key: Fuel3DOptionKey; label: string }[] = [
  { key: "canopy", label: "Canopy" },
  { key: "stems", label: "Stems" },
  { key: "surface", label: "Surface" },
  { key: "grass", label: "Grass" },
  { key: "buildings", label: "Buildings" },
  { key: "fire", label: "Fire" },
];

const FuelLoad3DControl: React.FC<FuelLoad3DControlProps> = ({
  layer,
  expanded,
  onExpandedChange,
  onPanelOpenChange,
}) => {
  const options = useFuel3DOptions();

  if (!layer) return null;

  const handleToggleVisibility = () => {
    layer.toolbarButton?.props?.onClick?.();
  };

  const optionsContent = (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.25 }}>
      {ROWS.map(({ key, label }) => (
        <Box
          key={key}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography sx={{ fontSize: 13, color: "#e2e8f0" }}>{label}</Typography>
          <Switch
            size="small"
            checked={options[key]}
            onChange={(e) => setFuel3DOption(key, e.target.checked)}
            sx={{
              "& .MuiSwitch-switchBase.Mui-checked": { color: "#00d4ad" },
              "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                backgroundColor: "#00d4ad",
              },
            }}
          />
        </Box>
      ))}
    </Box>
  );

  return (
    <LayerControlItem
      title="3D Layers"
      icon={<ThreeDShapesIcon />}
      visible={layer.active ?? false}
      onToggleVisibility={handleToggleVisibility}
      enabled={layer.toolbarButton?.props?.enabled ?? true}
      drawingContent={layer.active ? optionsContent : undefined}
      drawingContentLabel="Show"
      expanded={expanded}
      onExpandedChange={onExpandedChange}
      onPanelOpenChange={onPanelOpenChange}
    />
  );
};

export default FuelLoad3DControl;
